export const UI_SCHEMA = {
    basic: {
        field_name: {
            'ui:field': '/schemas/jsf-input'
        }
    }
};
export const SCHEMA = {
    type: 'object',
    properties: {
        basic: {
            type: 'object',
            title: 'Компонент: InputJsField',
            required: ['field_name'],
            properties: {
                field_name: {
                    title: 'Свойство',
                    type: ['string', 'null'],
                    minLength: 1,
                    $comment: 'кПа'
                }
            }
        }
    }
};
export const FORM_DATA = {
    basic: {
        field_name: 'E-100'
    }
};
//# sourceMappingURL=InputJsField.example.js.map